import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const normalizeList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

const bookingService = {
  getAllBookings: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/bookings`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return normalizeList(response.data);
  },

  searchBookings: async (filters = {}) => {
    return bookingService.getAllBookings(filters);
  },

  getBookingById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/bookings/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getBookingByReference: async (reference) => {
    const ref = String(reference || '').trim();
    try {
      const response = await axios.get(`${API_BASE_URL}/bookings/reference/${encodeURIComponent(ref)}`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (err) {
      if (err?.response?.status === 404) {
        const all = await bookingService.getAllBookings({ search: ref, limit: 50 });
        const q = ref.toLowerCase();
        const match = all.find(
          (b) =>
            String(b.bookingReference || '').toLowerCase() === q ||
            String(b.id || '').toLowerCase() === q
        );
        if (match) return match;
      }
      throw err;
    }
  },

  confirmBooking: async (id, adminNotes = null) => {
    const response = await axios.post(
      `${API_BASE_URL}/bookings/${id}/confirm`,
      { adminNotes },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateBookingStatus: async (id, statusData) => {
    const response = await axios.put(
      `${API_BASE_URL}/bookings/${id}/status`,
      statusData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  cancelBooking: async (id, cancellationReason = '') => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/bookings/${id}/cancel`,
        { cancellationReason: cancellationReason || 'Cancelled by admin' },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (err) {
      // Fallback to status endpoint if POST /cancel is unavailable or returns 404/405
      const response = await axios.put(
        `${API_BASE_URL}/bookings/${id}/status`,
        {
          status: 'Cancelled',
          cancellationReason: cancellationReason || 'Cancelled by admin',
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    }
  },
};

export default bookingService;
